import { useCallback, useContext, useEffect, useState } from "react";
import { config, searchRegex } from "../../../../constant";
import { useElement, useLocale, useService } from "../../../../hooks";
import { AppContext } from "../../../../context";

export const useKeyListAdmin = () => {
  const { t } = useLocale();
  const Badge = useElement("Badge");
  const { setTitle } = useService("Meta");
  const { actions: { showPreloader, hidePreloader } } = useContext(AppContext);
  const { getFormattedDate, getFormattedTime, isBottom } = useService("Misc");
  const { getKeysList } = useService("Order");
  const { commonPageSize } = config;
  const [tableContent, settableContent] = useState(null);
  const [activeShownTotal, setactiveShownTotal] =
    useState<number>(commonPageSize);
  const [tableData, settableData] = useState([]);
  const [searchKey, setsearchKey] = useState<string>("");
  const [filteredList, setfilteredList] = useState([]);

  setTitle(t("carKeysList"), "admin");

  const getCustomerKeysList = useCallback(async () => {
    const result = await getKeysList();
    if (result.status) {
      let tableData = result.data;
      settableData(tableData);
      setfilteredList(tableData);
    }
  }, [getKeysList]);

  useEffect(() => {
    getCustomerKeysList();
  }, [getCustomerKeysList]);

  const resetSearch = useCallback(() => {
    setfilteredList(tableData);
    setsearchKey("");
  }, [tableData]);

  const showMore = useCallback(() => {
    showPreloader();
    setTimeout(() => {
      hidePreloader();
      setactiveShownTotal(activeShownTotal + commonPageSize);
    }, 300);
  }, [activeShownTotal, commonPageSize, hidePreloader, showPreloader]);

  const trackScrolling = useCallback(() => {
    const wrappedElement = document.getElementById("list-wrapper");
    if (isBottom(wrappedElement)) {
      if (
        filteredList.length > commonPageSize &&
        activeShownTotal < filteredList.length
      )
        showMore();
    }
  }, [activeShownTotal, commonPageSize, filteredList, showMore, isBottom]);

  const getTableData = useCallback(
    (filterData) => {
      let data = [];
      filterData.forEach((item) => {
        let e = {
          registrationNo: item.registrationNo
            ? item.registrationNo.toUpperCase()
            : "",
          supervisorId: item.supervisorId,
          timing: (
            <>
              {getFormattedDate(item.timing)} <br />{" "}
              {getFormattedTime(item.timing)}
            </>
          ),
          status: <Badge item={item.status} />,
        };
        data.push(e);
      });
      return data;
    },
    [getFormattedDate, getFormattedTime, Badge]
  );

  const search = useCallback(
    (e) => {
      if (e.target.value === "" || searchRegex.test(e.target.value)) {
        setsearchKey(e.target.value);
        let tempTitle = "",
          filteredList = [];
        tableData.forEach((e) => {
          tempTitle = e.registrationNo ? e.registrationNo.toLowerCase() : "";
          if (tempTitle.search(searchKey) !== -1) filteredList.push(e);
        });
        setfilteredList(filteredList);
      }
    },
    [searchKey, tableData]
  );

  useEffect(() => {
    settableContent({
      headers: [
        {
          label: t("registrationNo"),
          key: "registrationNo",
        },
        {
          label: t("superviseId"),
          key: "superviseId",
        },
        {
          label: t("timing"),
          key: "timing",
        },
        {
          label: t("status"),
          key: "status",
        },
      ],
      content: getTableData(filteredList),
    });
  }, [filteredList, getCustomerKeysList, getTableData, t]);
  return {
    trackScrolling,
    searchKey,
    search,
    resetSearch,
    tableContent,
    activeShownTotal,
  };
};
